import { HStack, Text, VStack } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import BasicModal from './BasicModal';
import LargeButton from './LargeButton';

interface Props {
  showModal: boolean;
  handleNo: () => void;
  handleYes: () => void;
  onClose: () => void;
}

const LegacyAreYouSureModal: React.FC<React.PropsWithChildren<Props>> = ({
  showModal,
  children,
  handleNo,
  handleYes,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <BasicModal showModal={showModal} onClose={onClose}>
      <VStack maxW="40rem" spacing="8" p="6">
        <Text as="h1" fontSize="2xl" fontWeight="500">
          {t('Are you sure?')}
        </Text>
        <Text textAlign="center">{children}</Text>
        <HStack w="100%" spacing="2">
          <StyledLargeButton level="secondary" onClick={handleNo} fullwidth>
            {t('No')}
          </StyledLargeButton>
          <StyledLargeButton onClick={handleYes} fullwidth>
            {t('Yes')}
          </StyledLargeButton>
        </HStack>
      </VStack>
    </BasicModal>
  );
};

const StyledLargeButton = styled(LargeButton)`
  min-width: unset;
`;

export default LegacyAreYouSureModal;
